const mutations = {
  SET_RISK_MEASURES(state, payload) {
    const capitalgroupRiskMeasure = payload.riskMeasures.capitalgroupRiskMeasure;
    const mstarRiskMeasure = payload.riskMeasures.mstarRiskMeasure;

    state.cgBenchmark = {
      beta: capitalgroupRiskMeasure.CGBeta,
      captureRatioDown: capitalgroupRiskMeasure.CGCaptureRatioDown,
      captureRatioUp: capitalgroupRiskMeasure.CGCaptureRatioUp,
      indexID: capitalgroupRiskMeasure.CGIndexID,
      indexName: capitalgroupRiskMeasure.CGIndexName,
      riskMeasuresAsOfDate: capitalgroupRiskMeasure.CGRiskMeasuresAsOfDate,
      rSquared: capitalgroupRiskMeasure.CGRSquared,
      IndexFundShareClassID: capitalgroupRiskMeasure.IndexFundShareClassID
    };
    state.mstarBenchmark = {
      beta: mstarRiskMeasure.MStarBeta,
      captureRatioDown: mstarRiskMeasure.MStarCaptureRatioDown,
      captureRatioUp: mstarRiskMeasure.MStarCaptureRatioUp,
      asOfDate: mstarRiskMeasure.MStarFundAsOfDate,
      primaryBenchmarkID: mstarRiskMeasure.MStarPrimaryBenchmarkID,
      primaryBenchmarkName: mstarRiskMeasure.MStarPrimaryBenchmarkName,
      rSquared: mstarRiskMeasure.MStarRSquared,
      sharpeRatio: mstarRiskMeasure.MStarSharpeRatio,
      standardDeviation: mstarRiskMeasure.MStarStandardDeviation,
      mStarRiskMeasureYear: mstarRiskMeasure.MStarRiskMeasureYear,
      mStarBenchmarkStrategy: mstarRiskMeasure.MStarBenchmarkStrategy
    };
  }
};

const getters = {
  getCGBenchmark: state => state.cgBenchmark,
  getMstarBenchmark: state => state.mstarBenchmark
};

const state = {
  cgBenchmark: null,
  mstarBenchmark: null
};

export default {
  state,
  getters,
  mutations
};
